import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import css from './styles.scss';
import Button from '../legacy/Construction/Button';
import IconButton from '../IconButton';

function MassActionBarItem({
  action,
  renderIconButton,
  itemRef,
  keyProp,
}) {
  const {
    label,
    icon,
    onClick,
    disabled,
    tooltip,
    onTooltipView,
    disableTitleCasing,
  } = action;

  const tooltipShown = useRef(false);

  const handleTooltipShow = () => {
    if (!tooltipShown.current && typeof onTooltipView === 'function') {
      onTooltipView(action);
      tooltipShown.current = true;
    }
  };

  return (
    <span
      className={css.simpleTooltipWrapper}
      ref={itemRef}
      key={keyProp}
      onMouseEnter={tooltip ? handleTooltipShow : undefined}
      onFocus={tooltip ? handleTooltipShow : undefined}
    >

      {/* can not use the ToolTip component here as that is a tether component,
      and expects child which will trigger hover
      our mass action bar calculates width from unmeasured rendered child, and we pass the
      child inside the Tooltip it will render inside tether component which messes up the width calculation,
      hence using a simple CSS tooltip here
      */}

      {tooltip && <span className={css.simpleTooltip}>{tooltip}</span>}
      {
        renderIconButton
          ? (
            <IconButton
              title={label}
              name={icon}
              onClick={onClick}
              disabled={disabled}
              color="light"
            />
          )
          : (
            <Button
              label={label}
              icon={icon}
              onClick={onClick}
              disabled={disabled}
              disableTitleCasing={disableTitleCasing}
              type="primary"
              shouldUseIconComponent
            />
          )
      }
    </span>
  );
}

MassActionBarItem.propTypes = {
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    tooltip: PropTypes.node,
    onTooltipView: PropTypes.func,
    disableTitleCasing: PropTypes.bool,
  }).isRequired,
  renderIconButton: PropTypes.bool,
  itemRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  keyProp: PropTypes.string,
};

MassActionBarItem.defaultProps = {
  renderIconButton: false,
  itemRef: undefined,
  keyProp: undefined,
};

export default MassActionBarItem;
